import React, { useState, useEffect } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { Button, NativeSelect, Paper, Checkbox } from "@material-ui/core";
import MaterialTable from 'material-table';
import * as S from './formStyle';
import api from '../../../../services/api';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useMessageBox } from '../../../../context/MessageBox';
import excelIcon from '../../../../assets/images/excel48.png';
import pdfIcon from '../../../../assets/images/pdf.png';
import AnchorsLogoOptions from './AnchorsLogoOptions'


function OperationsMiddle({
  setTableData,
  setmediaCrescimento,
  setHeaderData,
  setTotalTableData,
  updateMetaData,
  setIsLoading,
  isLoading,
  setHideColumns,
  hideColumns,
  setAllowChange,
  anchors,
  handleSelectAnchor,
  selectedAnchor,
  scheduleDate,
  setScheduleDate,
  setLiberarMetasChanged,
  liberarMetasChanged
}) {
  const { periodo } = useParams();
  const classes = S.useStyles();
  const [mediaCrescimento, setmediaCrescimentoInternal] = useState(
    JSON.parse(sessionStorage.getItem('@Capittale-Web-Setting'))?.configuracoesAmbienteWeb?.find(
      (el) => el.parametroId === 63,
    )?.valor ?? 0,
  );
  const [hideColumnsText, setHideColumnsText] = useState('Mostrar colunas');
  const [report, setReport] = useState();
  const [mostrarIgnorados, setMostrarIgnorados] = useState('Todos')
  const [screenParams, setScreenParams] = useState({
    title: 'Relatório Metas',
    apiTable: 'Relatorios/Relatorio002Metas',
    apiDownload: 'Relatorios/Relatorio002MetasDownloadExcel',
    apiDownloadExcel: 'Relatorios/Relatorio002MetasDownloadExcel',
    apiUpdate: 'Relatorios/Relatorio002MetasAtualizarMetas',
    dateFormat: 'MM/yyyy',
  });

  const { setMessageData } = useMessageBox();

  useEffect(async () => {
    if (mediaCrescimento && selectedAnchor) {
      await getInfoForForm();
    }
  }, [scheduleDate, mediaCrescimento, selectedAnchor, mostrarIgnorados]);

  useEffect(async () => {
    if (mediaCrescimento && selectedAnchor && liberarMetasChanged) {
      setLiberarMetasChanged(false)
      await getInfoForForm();
    }
  }, [liberarMetasChanged]);

  useEffect(() => {
    const initialize = async () => {
      setIsLoading(true);
      setIsLoading(false);
    };
    initialize();
  }, []);

  useEffect(async () => {
    if (updateMetaData) {
      const model = {
        anoMeta: new Date(scheduleDate).getFullYear(),
        mesMeta: new Date(scheduleDate).getMonth() + 1,
        metas: updateMetaData,
      };
      const response = await api.post(screenParams.apiUpdate, model);

      if (response?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(response?.data?.complemento?.mensagensBox);
      }

      if (response.data.status !== 'Sucesso') {
        if (response.data.resposta) {
          if (response.data.resposta.length > 0) {
            response.data.resposta.forEach((element) => {
              toast.error(element.message);
            });

            return;
          }
        }
      }

      toast.success('Meta atualizada com sucesso!');
      getInfoForForm();
    }
  }, [updateMetaData]);

  const getInfoForForm = async () => {
    const model = {
      mediaCrescimento: parseFloat(mediaCrescimento),
      anoMeta: new Date(scheduleDate).getFullYear(),
      mesMeta: new Date(scheduleDate).getMonth() + 1,
      ancoraId: selectedAnchor.ancoraId ? selectedAnchor.ancoraId : 0,
      plataformaId: selectedAnchor.plataformaId ? selectedAnchor.plataformaId : 0,
      filtroMostrarIgnorados: mostrarIgnorados,
    };
    setReport(model);
    setIsLoading(true);
    try {
      const relatorio = await api.post(screenParams.apiTable, model);

      setTableData(relatorio.data.resposta?.itens);
      setTotalTableData(relatorio.data.resposta?.totalizador);
      setAllowChange(relatorio.data.resposta?.permiteAlteracao)

      if (relatorio?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(relatorio?.data?.complemento?.mensagensBox);
      }

      if (relatorio.data.status !== 'Sucesso') {
        if (relatorio.data.resposta) {
          if (relatorio.data.resposta.length > 0) {
            relatorio.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }

        setIsLoading(false);
      } else {
        setHeaderData(relatorio.data.resposta);
        setmediaCrescimento(mediaCrescimento);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const exportTable = async (pdf) => {
    if (!report || pdf) return;

    setIsLoading(true);

    try {
      const url = pdf ? screenParams.apiDownload : screenParams.apiDownloadExcel;
      const relatorio = await api.post(url, report);

      if (relatorio?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(relatorio?.data?.complemento?.mensagensBox);
      }

      if (relatorio.data.status !== 'Sucesso') {
        if (relatorio.data.resposta) {
          if (relatorio.data.resposta.length > 0) {
            relatorio.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }
        return;
      }

      const a = document.createElement('a');
      a.href =
        'data:' +
        relatorio.data.resposta.contentType +
        ';base64,' +
        relatorio.data.resposta.fileContents;
      a.download = relatorio.data.resposta.fileDownloadName;
      a.click();
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const cleanValues = () => {
    const elements = document.getElementsByTagName('input');
    for (let i = 0; i < elements.length; ++i) {
      if (
        elements[i].id.includes('Volume') ||
        elements[i].id.includes('Receita') ||
        elements[i].id.includes('QuantidadeOperacoes') ||
        elements[i].id.includes('QuantidadeQualificados')
      ) {
        // elements[i].setAttribute('value', '0,00');
        elements[i].value = '0,00';
      }
    }
  };

  return (
    <>
      <div style={{ height: '100%' }}>
        <div
          className="new-body-schedule"
          style={{ justifyContent: 'space-between', display: 'flex', marginTop: '20px', alignItems: 'center' }}
        >
          <div style={{ minWidth: '20%' }}>
            <AnchorsLogoOptions
              anchors={anchors}
              handleSelectAnchor={handleSelectAnchor}
              selectedAnchor={selectedAnchor}
            />
          </div>
          <div className="schedule-input" 
            style={{ display: "flex", margin: "8px", alignItems: 'center', flexDirection: 'column' }}
          >
            <span className={classes.label}>Mês/Ano: </span>
            <div style={{ display: "flex", alignItems: 'center' }}>
              <Button
                style={{ minWidth: '20px', width: '20px', height: '23px', paddingLeft: '20px' }}
                onClick={() => {
                  const newDate = new Date(scheduleDate);
                  if (periodo === 'diario') {
                    cleanValues();
                    setScheduleDate(newDate.setDate(newDate.getDate() - 1));
                  } else {
                    cleanValues();
                    setScheduleDate(newDate.setMonth(newDate.getMonth() - 1));
                  }
                }}
              >
                🢀
              </Button>

              <div style={{ padding: '0px 5px', maxWidth: '200px', height: '23px' }}>
                <DatePicker
                  style={{ width: '100px' }}
                  selected={scheduleDate}
                  onChange={(date) => setScheduleDate(date)}
                  dateFormat={screenParams.dateFormat}
                  locale="ptBR"
                />
              </div>

              <Button
                style={{ minWidth: '20px', width: '20px', height: '23px' }}
                onClick={() => {
                  const newDate = new Date(scheduleDate);
                  if (periodo === 'diario') {
                    setScheduleDate(newDate.setDate(newDate.getDate() + 1));
                  } else {
                    setScheduleDate(newDate.setMonth(newDate.getMonth() + 1));
                  }
                }}
              >
                🢂
              </Button>
            </div>
          </div>
          <div style={{ display: 'flex', marginTop: '8px', alignItems: 'center', flexDirection: 'column', whiteSpace:'nowrap'  }}>
            <span className={classes.label}>Média de crescimento: </span>
            <div style={{ display: "flex", alignItems: 'center' }}>
              <input
                style={{ maxWidth: '50px' }}
                value={mediaCrescimento}
                type="text"
                onChange={(e) => {
                  const value = e.target.value.replace(',', '.');
                  if (value >= 0 && value <= 100) {
                    const decimalPlaces = value.toString()?.includes('.')
                      ? value.toString()?.split('.')[1].length
                      : 0;
                    if (decimalPlaces <= 2) {
                      setmediaCrescimentoInternal(value);
                    }
                  } else if (value < 0) {
                    toast.error('O valor deve ser positivo.');
                  }
                }}
                onBlur={(e) => {
                  setmediaCrescimentoInternal(parseFloat(e.target.value).toFixed(2));
                }}
              />
              <span>&nbsp; %</span>
            </div>
          </div>
          <div>
            <label className={classes.label}>Mostrar Ignorados</label>
            <Paper className={classes.medium} elevation={0}>
              <NativeSelect
                name="destinoPagamentos"
                className={classes.input}
                onChange={(e) => {
                  setMostrarIgnorados(e.target.value)
                }}
                value={mostrarIgnorados}
              >
                <option value="Todos">Todos</option>
                <option value="Ignorados">Ignorados</option>
                <option value="NaoIgnorados">Não Ignorados</option>
              </NativeSelect>
            </Paper>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', height: '60px' }}>
            <Button
              color="primary"
              variant="contained"
              style={{ marginRight: '10px' }}
              disabled={isLoading}
              onClick={(e) => {
                setHideColumns(!hideColumns);
                setHideColumnsText(
                  hideColumnsText === 'Mostrar colunas' ? 'Esconder colunas' : 'Mostrar colunas',
                );
              }}
            >
              {hideColumnsText}
            </Button>
            <img
              src={excelIcon}
              onClick={() => {
                exportTable(false);
              }}
              style={{ cursor: 'pointer', marginRight: '8px' }}
            ></img>
            {/* <img src={pdfIcon} onClick={() => { exportTable(true) }} style={{ cursor: 'default', marginBottom: '4px' }} width="40"></img> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default OperationsMiddle;
